export const getQueryParamsFromUrl = (searchString) => {
  try {
    return searchString
      .split("?")[1]
      .split("&")
      .map((k) => {
        const e = k.split("=");
        return (e[0] && { [e[0]]: decodeURIComponent(e[1]) }) || null;
      })
      .reduce((prev, curr) => curr && { ...prev, ...curr }, {});
  } catch (e) {
    return null;
  }
};

export const scrollTo = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
};

export const profileCharacters = (firstName, lastName) => {
  let chars = "";
  if (firstName && firstName.length > 0) {
    chars += firstName[0].toUpperCase();
  }

  if (lastName && lastName.length > 0) {
    chars += lastName[0].toUpperCase();
  }
  return chars;
};

export const setAuth = () => {
  localStorage.setItem(
    "BlogsConsumerToken",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImRiYzNlZGEzLTNhNGMtNGZmYi04NzZjLWU1NTY5MDQ0YzVmYyIsImVtYWlsIjoic2FtcGxlQHlvcG1haWwuY29tIiwic3RhdHVzIjoiYWN0aXZlIiwicm9sZSI6InVzZXIiLCJpYXQiOjE2MTA5NzI4OTh9.aC6ZsD1G7WNzYQtRFkoRJzV0OG38aGr9O-LJafIv8y8"
  );
  localStorage.setItem(
    "BlogsConsumerUser",
    JSON.stringify({
      id: "dbc3eda3-3a4c-4ffb-876c-e5569044c5fc",
      firstName: "sample",
      lastName: null,
      email: "sample@yopmail.com",
      gender: "None",
      title: null,
      phoneNumber: null,
      role: "user",
      status: "active",
      profileImage: null,
      blogCount: 0,
      postCount: 0,
      followerCount: 0,
      followingCount: 0,
      token:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImRiYzNlZGEzLTNhNGMtNGZmYi04NzZjLWU1NTY5MDQ0YzVmYyIsImVtYWlsIjoic2FtcGxlQHlvcG1haWwuY29tIiwic3RhdHVzIjoiYWN0aXZlIiwicm9sZSI6InVzZXIiLCJpYXQiOjE2MTA5NzI4OTh9.aC6ZsD1G7WNzYQtRFkoRJzV0OG38aGr9O-LJafIv8y8",
    })
  );
};
